import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { SeasonLink as Link } from "../../components/Seasons/SeasonLink";
import { completeLeaderIdCallback } from '../../api/auth';
import { useAuth } from '../../context/AuthContext';

export function LeaderIdCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshSession } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const code = searchParams.get('code') || '';
      const state = searchParams.get('state') || '';
      if (!code || !state) {
        if (!cancelled) {
          setError('Не удалось завершить вход через Leader-ID: отсутствуют code/state.');
        }
        return;
      }

      try {
        await completeLeaderIdCallback(code, state);
        await refreshSession();
        if (!cancelled) {
          navigate('/my-season', { replace: true });
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Не удалось завершить вход через Leader-ID.');
        }
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [navigate, refreshSession, searchParams]);

  return (
    <div className="auth-container">
      <div className="auth-form-container" style={{ width: '100%' }}>
        <div className="auth-card">
          <h1 className="auth-title">Вход через Leader-ID</h1>
          {!error ? (
            <p className="auth-link">Завершаем авторизацию, подождите...</p>
          ) : (
            <>
              <p className="auth-link">{error}</p>
              <p className="auth-link">
                <Link to="/login" className="auth-link-register">Вернуться ко входу</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

